
import { Component, Prop, Vue, Provide, Inject } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import ZhiCustomBtn from './zhiCustomBtn.vue'

@Observer
@Component({
  components: {
    ZhiCustomBtn
  }
})
export default class extends Vue {
  yt_tong_nor = `${this.$store.$global.static}/images/xt_tong_normal-v2.png`

  get hideFab() {
    return ['playback', 'live', 'course-id', 'new-course-id', 'guide-live', 'auth-wechat'].includes(this.$route.name ?? '')
  }

  onSubmit() {}
  mounted() {}
  updated() {}
  destroyed() {}
  toTop() {
    // 保留注销协议的回顶操作
    if (this.$route.name!.includes('deletion')) {
      this.$router.replace({
        query: {
          action: 'toTop'
        }
      })
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
